import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useVideoFade } from "../lib/useVideoFade";
import { VIDEOS, POSTERS } from "../lib/media";

export default function Hero() {
  const videoRef = useVideoFade();

  return (
    <section id="home" className="min-h-screen bg-black overflow-hidden relative flex flex-col">
      {/* Instant still frame; the playing video fades in over it once loaded */}
      <img
        src={POSTERS.hero}
        alt=""
        aria-hidden="true"
        className="hero-media hero-media--poster"
      />
      <video
        ref={videoRef}
        className="hero-media"
        src={VIDEOS.hero}
        autoPlay
        muted
        playsInline
        preload="auto"
        style={{ opacity: 0 }}
      />
      <div className="vignette" aria-hidden="true" />

      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-12 text-center pt-20 md:pt-24 -translate-y-[14%] md:-translate-y-[18%]">
        <Reveal kind="reveal-soft" delay={0}>
          <div className="liquid-glass rounded-full px-4 py-1.5 text-white/70 text-xs tracking-widest uppercase inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-white/80 pulse-dot" />
            Pioneers · AI · AU · NZ · Global
          </div>
        </Reveal>

        <Reveal delay={120}>
          <h1 className="font-instrument text-6xl md:text-8xl lg:text-9xl text-white mt-6 mb-10 tracking-tight whitespace-nowrap" style={{ lineHeight: 0.95 }}>
            Built for the <em className="italic-serif text-white/85">bold</em>.
          </h1>
        </Reveal>

        <div className="max-w-xl w-full space-y-4">
          <Reveal kind="reveal-soft" delay={360}>
            <p className="text-white text-sm leading-relaxed px-4">
              We help ambitious organisations become part of the AI revolution - building the products, systems and capability they need to lead it.
            </p>
          </Reveal>

          <Reveal kind="reveal-soft" delay={480}>
            <div className="pt-2 flex justify-center gap-3 flex-wrap">
              <a href="/manifesto.html" className="liquid-glass rounded-full px-8 py-3 text-white text-sm font-medium hover:bg-white/5 transition-colors">
                Read the manifesto
              </a>
              <a href="#contact" className="rounded-full px-8 py-3 text-black text-sm font-medium bg-white hover:bg-white/90 transition-colors inline-flex items-center gap-2">
                Book a discovery <ArrowRight size={16} />
              </a>
            </div>
          </Reveal>
        </div>
      </main>

    </section>
  );
}
